{
  "drawMoreButton": "dessiner plus de champs",
  "drawPolygonInstructions": "Dessinez votre polygone en appuyant sur la carte.",
  "fieldLabelsToggle": "Afficher/masquer les étiquettes des champs",
  "fieldTypePolygon": "Polygone",
  "helpBodyText": "Créez des champs pour représenter les zones de votre ferme. Les champs sont utilisés pour suivre les équipements et les événements d'irrigation.",
  "helpTitle": "À propos de la création de champs",
  "linkTo": "Nouveau champ",
  "manageFieldButton": "Gérer le champ",
  "notEnoughPoints": "Assurez-vous que votre champ comporte au moins 3 points et qu'il est fermé.",
  "restartButtonText": "Redémarrage",
  "retartButton": "Recommencer",
  "setNameInstructions": "Entrez un nom pour votre champ.",
  "setRowDirectionInstructions": "Utilisez le curseur pour définir la direction des lignes de votre champ.",
  "successInstructions": "Votre champ a été créé.",
  "title": "Nouveau champ",
  "undoButtonText": "Défaire"
}
